import { render, staticRenderFns } from "./PlanBetterComponent.vue?vue&type=template&id=3ac609a0"
import script from "./PlanBetterComponent.vue?vue&type=script&lang=js"
export * from "./PlanBetterComponent.vue?vue&type=script&lang=js"
import style0 from "./PlanBetterComponent.vue?vue&type=style&index=0&id=3ac609a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports